import React from 'react'
import { useIntl } from 'react-intl'
import Link from '../Link'

import { tagContainer } from './index.module.css'

import { getLocaleData } from '../../utils'

const WpTag = ({ tag, location }) => {
  let t = tag
  const intl = useIntl()
  const homeUrl = intl.formatMessage({ id: 'blog.homeUrl' })
  return (
    <Link
      to={`${homeUrl}tag/${t.slug.replace('-zh-hans', '').replace('-ja', '')}`}
    >
      <span className={tagContainer}>{t.name}</span>
    </Link>
  )
}

export default WpTag
